import { commonService } from '.';

const getUserNoKp = (body) => {
    return commonService.getWithParam('KeyPeople/userNoKp', body);
}

const getKeyPeopleData = (body) => {
    return commonService.getWithParam('KeyPeople', body);
}

const updateKeyPeopleData = (body) => {
    return commonService.put('KeyPeople', body);
};

export const keyPeopleService = {
    getUserNoKp,
    getKeyPeopleData,
    updateKeyPeopleData
};
